module.exports = __webpack_public_path__ + "img/google-elipse.d7c251c9.svg";